var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ViewContainerRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MdDialog } from '@angular/material';
import { Router } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import * as moment from 'moment';
import 'moment-timezone';
// Patch Africa/Casablanca with IANA tzdata 2026c: Morocco switches
// permanently to UTC+0 on 2026-09-20 at 02:00 local (01:00 UTC).
// moment-timezone bundles IANA 2025b which doesn't have this transition.
// Guard: skip if moment-timezone already has correct data (offset=0 after Sep 20).
(function patchCasablancaZone() {
    var tz = moment.tz;
    var zone = tz && tz.zone('Africa/Casablanca');
    if (!zone)
        return;
    var oct2026 = 1790992800000; // 2026-10-01T10:00:00Z — a date after the transition
    var idx = zone.untils.findIndex(function (u) { return u > oct2026; });
    if (idx < 0 || zone.offsets[idx] === 0)
        return; // already correct
    var transitionMs = 1789866000000; // 2026-09-20T01:00:00Z
    var i = 0;
    while (i < zone.untils.length && zone.untils[i] <= transitionMs)
        i++;
    zone.untils.splice(i, zone.untils.length - i, transitionMs, Infinity);
    zone.offsets.splice(i, zone.offsets.length - i, -60, 0);
    zone.abbrs.splice(i, zone.abbrs.length - i, '+01', '+00');
})();
import { AppConfig } from './../../Common/appConfiguration';
import { AppMessage } from './../../Common/appMessage';
import { GaService } from './../../Common/ng2-date-picker/ga.service';
import { AppGlobals } from './../../Common/Services/app.global';
import { Utility } from './../../Common/Services/utility';
import { DialogConfirmComponentComponent } from './../dialog-confirm-component/dialog-confirm-component.component';
import { ManageChildHeadersService } from '././../../Common/Services/manage-child-headers.service';
import { ScheduleExamDateService } from './schedule-exam-date.service';
import { userRole_globalAdmin } from "./../../Common/appConstant";
var ScheduleExamDateComponent = (function () {
    function ScheduleExamDateComponent(_utility, _router, _scheduleExamDateService, _dialog, _vcr, gaService, _manageChildHeadersService, _appMessage, _appConfig, _appGlobals) {
        this._utility = _utility;
        this._router = _router;
        this._scheduleExamDateService = _scheduleExamDateService;
        this._dialog = _dialog;
        this._vcr = _vcr;
        this.gaService = gaService;
        this._manageChildHeadersService = _manageChildHeadersService;
        this._appMessage = _appMessage;
        this._appConfig = _appConfig;
        this._appGlobals = _appGlobals;
        this.selectedExamModel = {};
        this.selectedExamLocationModel = {};
        this.examDateModel = {};
        this.hideConflictTypes = ["locHoursOfOperation", "uniHoursOfOperation", "expired"];
        this.my_Class = 'inactive';
        this.scheduleForm = new FormGroup({
            phoneNumber: new FormControl('', [Validators.required, Validators.pattern(AppConfig.phoneNumberRegEx)]),
            certificateId: new FormControl('', Validators.pattern(AppConfig.certificateIDRegEx))
        });
        // set global admin flag
        var role = this._appGlobals.userInfo.getValue().userRole;
        role = role && role.toUpperCase();
        this.isGlobalAdmin = role == userRole_globalAdmin;
    }
    ScheduleExamDateComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this._appGlobals.selectedExamModel || (!this._appGlobals.selectedExamLocationModel && !this._utility.usesVirtualLocation(this._appGlobals.selectedExamModel))) {
            this._router.navigate([(this._utility.leftMenusList_CUser && this._utility.leftMenusList_CUser.landingUrl) ? this._utility.leftMenusList_CUser.landingUrl : '/**']);
            return;
        }
        else {
            this.selectedExamModel = this._appGlobals.selectedExamModel;
            if (!this._utility.usesVirtualLocation(this.selectedExamModel)) {
                this.selectedExamLocationModel = this._appGlobals.selectedExamLocationModel;
            }
            this.timezoneId = (!this._utility.usesVirtualLocation(this.selectedExamModel)) ? this.selectedExamLocationModel.timeZoneId : this.selectedExamModel.virtualLocationTimeZone.id;
            this.timeZone = (!this._utility.usesVirtualLocation(this.selectedExamModel)) ? this.selectedExamLocationModel.timeZone : this.selectedExamModel.virtualLocationTimeZone.name;
            this.locationId = (!this._utility.usesVirtualLocation(this.selectedExamModel)) ? this.selectedExamLocationModel.id : 0;
            this.koalaId = (this.selectedExamModel.examType == "CE"
                ? this.selectedExamLocationModel.koalas[0].id
                : null);
            this._utility.setTxnStatus(true);
            this.animatedClass = false;
            this.examDateModel = {
                selectedCalDate: new Date(),
                timeSlotsByDate: [],
                selectedTimeSlot: { iso: null, date: null, time: null },
                showDiv: 2,
                tncChecked: false,
                submitInProcess: false
            };
            if (this._appGlobals.userId === 0) {
                this._scheduleExamDateService.getProfile().subscribe(function (profile) {
                    _this.updateScheduleForm(profile);
                });
            }
            var cDate = new Date();
            this.minDate = new Date(cDate.getFullYear(), cDate.getMonth(), cDate.getDate());
            this.maxDate = this._utility.convertToDateTime(this.selectedExamModel.eligibilityExpirationDate); //this.selectedExamModel.expirationDate;
            this.bypassFilters = new Set(this._appGlobals.userPermissions.getValue().has("exam-sessions.bypass.filter.proctoring-capacity")
                ? ["proctoring-capacity"]
                : []);
            this.calConfig = {
                min: moment(this.minDate),
                max: moment(this.maxDate),
                firstDayOfWeek: 'su',
                monthFormat: 'MMM, YYYY',
                disableKeypress: true,
                allowMultiSelect: false,
                onOpenDelay: 0,
                weekDayFormat: 'dd',
                showNearMonthDays: false,
                showWeekNumbers: false,
                enableMonthSelector: true,
                yearFormat: 'YYYY',
                showGoToCurrent: true,
                dayBtnFormat: 'D',
                monthBtnFormat: 'MMM',
                hours12Format: 'hh',
                hours24Format: 'HH',
                meridiemFormat: 'A',
                minutesFormat: 'mm',
                minutesInterval: 1,
                secondsFormat: 'ss',
                secondsInterval: 1,
                showSeconds: false,
                showTwentyFourHours: false,
                timeSeparator: ':',
                multipleYearsNavigateBy: 1,
                showMultipleYearsNavigation: false,
                locale: 'en'
            };
            this.setTimeSlots();
        }
    };
    ScheduleExamDateComponent.prototype.getVirtualLocationCountryId = function () {
        if (this.selectedExamModel.virtualLocationCountry) {
            return this.selectedExamModel.virtualLocationCountry.id;
        }
        return "";
    };
    ScheduleExamDateComponent.prototype.getLocationCountryAlpha2Code = function () {
        var code = this.selectedExamModel.virtualLocationCountry.code;
        if (typeof code !== "string" || !/^[A-Z]{2}$/.test(code)) {
            throw new Error("Could not determine country alpha 2 code");
        }
        return code;
    };
    ScheduleExamDateComponent.prototype.onCertIDFieldKeyup = function () {
        var field = this.scheduleForm.controls.certificateId;
        var formattedValue = this._utility.textFormat(field.value, 3, "-"); // format text with "-"
        field.setValue(formattedValue.substring(0, 30)); // substring(0, 30) -- this logic works if someone long press any key then only take start 30 inputs only
    };
    // to reserve the exam
    ScheduleExamDateComponent.prototype.reserveExam = function () {
        var _this = this;
        if (this.scheduleForm.invalid) {
            return;
        }
        this.examDateModel.submitInProcess = true;
        var profilePatchBody = {
            phone: this.scheduleForm.controls.phoneNumber.value,
        };
        var certificateId = this.scheduleForm.controls.certificateId.value;
        if (certificateId) {
            profilePatchBody.certificate = {
                id: certificateId,
            };
        }
        this._scheduleExamDateService.updateProfile(profilePatchBody)
            .switchMap(function (profile) {
            _this.updateScheduleForm(profile);
            var scheduleExamBody = {
                location: _this.selectedExamModel.examType === "CE" ? {
                    koala: { id: _this.koalaId },
                } : {
                    timezone: _this.selectedExamModel.virtualLocationTimeZone.name,
                    country: _this.getLocationCountryAlpha2Code(),
                },
                eligibility: {
                    code: _this.selectedExamModel.eligibilityCode,
                },
                exam: {
                    sku: _this.selectedExamModel.examCode,
                },
                start: _this.examDateModel.selectedTimeSlot.iso,
                bypass_filters: Array.from(_this.bypassFilters),
            };
            return _this._scheduleExamDateService.scheduleExam(_this.selectedExamModel.examType, scheduleExamBody);
        })
            .subscribe(function (uuid) {
            _this.examDateModel.submitInProcess = false;
            _this._utility.onSuccessCallback({
                responseCode: "S0001",
                responseDescription: "Success",
                response: uuid,
            }, null, function () {
                _this._appGlobals.selectedExamModel = null;
                _this._appGlobals.selectedExamLocationModel = null;
                _this._utility.clearTxnStatus();
                _this._dialog.open(DialogConfirmComponentComponent, {
                    data: {
                        modelType: "SUCCESS",
                        msgTitle: _this._appMessage.getItem['Common013'],
                        msg: _this.selectedExamModel.isReschedule == true ? _this._appMessage.getItem['UMsg00024'] : _this._appMessage.getItem['UMsg00025'],
                        showDefaultBtn: true,
                        defaultBtnCaption: _this._appMessage.getItem['Common011'],
                        redirectUrl: _this._utility.isAdminAsCandidate() ? "/AdmManageEligibilities" : "/Dashboard"
                    }
                });
            });
        }, function (error) {
            _this._utility.removeLoaderCount();
            _this.showErrorModal(error);
        });
    };
    /**
     * back to TimeList
     * this.examDateModel.tncChecked - used to handle checkbox corresponding to I Agree for terms and conditions
     * showDiv - ot hide/show div in html(1-show text,2-show slots,3-show scheduling,4-show Rescheduling)
     */
    ScheduleExamDateComponent.prototype.backToTimeList = function () {
        this.examDateModel.tncChecked = false;
        this.examDateModel.showDiv = 2;
        this.my_Class = this.my_Class == "inactive" ? 'active animated' : 'inactive';
        this.setTimeSlots();
    };
    ScheduleExamDateComponent.prototype.updateScheduleForm = function (profile) {
        this.scheduleForm.setValue({
            phoneNumber: profile.phone || "",
            certificateId: profile.certificate.id || "",
        });
    };
    // date selected event of calendar
    ScheduleExamDateComponent.prototype.dateSelected = function (event) {
        var date = new Date(event.date);
        this.examDateModel.selectedCalDate = date;
        this.examDateModel.showDiv = 2; // show slots div
        this.examDateModel.tncChecked = false;
        this.setTimeSlots();
    };
    // to get and set timeslots
    ScheduleExamDateComponent.prototype.setTimeSlots = function () {
        var _this = this;
        this.examDateModel.timeSlotsByDate = [];
        this.examDateModel.selectedTimeSlot.iso = null;
        this.examDateModel.selectedTimeSlot.date = null;
        this.examDateModel.selectedTimeSlot.time = null;
        var selectedMonth = this.examDateModel.selectedCalDate.getMonth();
        var selectedDay = this.examDateModel.selectedCalDate.getDate();
        var selectedYear = this.examDateModel.selectedCalDate.getFullYear();
        var fromDateStr = selectedYear
            + "-" + ((selectedMonth + 1) >= 10 ? (selectedMonth + 1) : '0' + (selectedMonth + 1))
            + "-" + (selectedDay >= 10 ? selectedDay : '0' + selectedDay);
        this._utility.addLoaderCount();
        var start = moment(this.examDateModel.selectedCalDate);
        var end = start.clone().add(1, 'weeks');
        var urlParams = "?eligibility=" + this.selectedExamModel.eligibilityCode;
        urlParams += "&sku=" + this.selectedExamModel.examCode;
        if (this.selectedExamModel.examType == "CE") {
            urlParams += "&koala=" + this.koalaId;
        }
        urlParams += "&start=" + start.toISOString();
        urlParams += "&end=" + end.toISOString();
        urlParams += "&duration=PT15M";
        if (this.isGlobalAdmin) {
            urlParams += Array.from(this.bypassFilters).map(function (bypass) { return "&bypass_filters=" + bypass; }).join("");
        }
        this._scheduleExamDateService.getExamSlots(this.selectedExamModel.examType, urlParams)
            .subscribe(function (possible_starts) {
            _this._utility.onSuccessCallback({
                responseCode: "S0001",
                responseDescription: "Success",
                response: possible_starts,
            }, null, function () {
                var slotSetDate = null;
                var slotSetHour = null;
                var tz = _this.timeZone;
                var dateToSlotMap = Array.from({ length: 7 })
                    .map(function (_, index) { return start.clone().add(index, 'days'); })
                    .map(function (value) { return moment(value).tz(tz).format('YYYY-MM-DD'); })
                    .reduce(function (accumulator, date) {
                    accumulator[date] = _this.createSlotSetDate(date);
                    return accumulator;
                }, {});
                Object.keys(dateToSlotMap)
                    .map(function (key) { return dateToSlotMap[key]; })
                    .forEach(function (value) { return _this.examDateModel.timeSlotsByDate.push(value); });
                possible_starts
                    .map(function (possible_start) {
                    var m = moment(possible_start).tz(tz);
                    return {
                        iso: possible_start,
                        date: m.format('YYYY-MM-DD'),
                        time: m.format('HH:mm:ss'),
                        conflictTypes: [],
                    };
                }).map(function (datetime) { return (__assign({}, datetime, { time: datetime.time.split(":").splice(0, 2).join(":"), hour: datetime.time.split(":").splice(0, 1)[0], isOpen: true, display: !datetime.conflictTypes || !_this.hideConflictTypes.some(function (ct) { return datetime.conflictTypes.includes(ct); }) })); }).forEach(function (ts) {
                    slotSetDate = dateToSlotMap[ts.date];
                    slotSetHour = slotSetDate.timeSlotsByHour.find(function (_a) {
                        var hour = _a.hour;
                        return hour === ts.hour;
                    });
                    if (slotSetHour === undefined) {
                        slotSetHour = _this.createSlotSetHour(ts.hour);
                        slotSetDate.timeSlotsByHour.push(slotSetHour);
                    }
                    slotSetHour.timeSlots.push(ts);
                    if (ts.display)
                        slotSetHour.display = true;
                    if (ts.isOpen)
                        slotSetHour.hasOpenSlots = true;
                    if (slotSetHour.hasOpenSlots)
                        slotSetDate.hasOpenSlots = true;
                });
            });
        }, function (error) {
            _this._utility.removeLoaderCount();
            _this.showErrorModal(error);
        }, function () { });
    };
    ScheduleExamDateComponent.prototype.createSlotSetDate = function (date) {
        return {
            date: new Date(date), timeSlotsByHour: [],
            dateStr: date, hasOpenSlots: null,
        };
    };
    ScheduleExamDateComponent.prototype.createSlotSetHour = function (hour) {
        return {
            time: hour + ':00', hour: hour, timeSlots: [],
            hasOpenSlots: null, expanded: false, display: null,
        };
    };
    ScheduleExamDateComponent.prototype.timeSlotIsOpen = function (timeSlot) {
        if (!timeSlot)
            return false;
        return !timeSlot.conflictTypes || (timeSlot.conflictTypes.length == 1 && this.isGlobalAdmin && timeSlot.conflictTypes[0] == "concurrent");
    };
    ScheduleExamDateComponent.prototype.toggleSlotSet = function (slotSet) {
        if (!slotSet.hasOpenSlots)
            return;
        slotSet.expanded = !slotSet.expanded;
    };
    // on selection of time, confirmation box is shown for status true
    ScheduleExamDateComponent.prototype.selectTimeSlot = function (timeSlot) {
        var _this = this;
        if (!timeSlot.isOpen)
            return;
        // warn about scheduling a concurrent exam
        if (timeSlot.conflictTypes && timeSlot.conflictTypes.indexOf("concurrent") > -1) {
            var confirmDialogMsgModel = {
                modelType: "CONFIRMATION",
                msgTitle: this._appMessage.getItem['Common007'],
                msg: this._appMessage.getItem["UMsg00079"],
                isConfirmBox: true,
                confirmBtnCaption: this._appMessage.getItem['Common014'],
                cancelBtnCaption: this._appMessage.getItem['Common015'],
            };
            this._dialog.open(DialogConfirmComponentComponent, {
                data: confirmDialogMsgModel
            }).afterClosed().subscribe(function (result) {
                if (result == "1")
                    _this.onSelectedTimeSlot(timeSlot);
            });
        }
        else {
            this.onSelectedTimeSlot(timeSlot);
        }
    };
    //On selection of time, proceed for confirmation screen
    ScheduleExamDateComponent.prototype.onSelectedTimeSlot = function (timeSlot) {
        this.examDateModel.showDiv = this.selectedExamModel.isReschedule ? 4 : 3;
        this.examDateModel.selectedTimeSlot = timeSlot;
    };
    // to show the direction of exam centre in google map
    ScheduleExamDateComponent.prototype.locateUs = function (lat, lng) {
        window.opener = null;
        window.open("https://maps.google.com/?q=" + lat + "," + lng);
    };
    // Show error modal with detail message from API response
    ScheduleExamDateComponent.prototype.showErrorModal = function (error) {
        var _this = this;
        var errorMessage = "An error occurred. Please try again.";
        // Extract detail message from error response
        if (error && error.error && error.error.detail) {
            errorMessage = error.error.detail;
        }
        else if (error && error.detail) {
            errorMessage = error.detail;
        }
        this._dialog.open(DialogConfirmComponentComponent, {
            data: {
                modelType: "ERROR",
                msgTitle: "Error",
                msg: errorMessage,
                showDefaultBtn: true,
                defaultBtnCaption: this._appMessage.getItem['Common011'] || 'OK'
            }
        }).afterClosed().subscribe(function () {
            _this.goBackToPreviousRoute();
        });
    };
    // Navigate back to the appropriate route
    ScheduleExamDateComponent.prototype.goBackToPreviousRoute = function () {
        var redirectUrl = this._utility.isAdminAsCandidate() ? "/AdmManageEligibilities" : "/Dashboard";
        this._router.navigate([redirectUrl]);
    };
    return ScheduleExamDateComponent;
}());
export { ScheduleExamDateComponent };



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/schedule-exam-date/schedule-exam-date.component.ts.pre-build-optimizer.js